export class Indicator {
  idIndicator: number;
  name: string;
  math: string | null;
  locked: boolean;

  constructor(
    idIndicator: number,
    name: string,
    math: string | null,
    locked: boolean,
  ) {
    this.idIndicator = idIndicator;
    this.name = name;
    this.math = math;
    this.locked = locked;
  }

  static fromRaw(raw: any): Indicator {
    return new Indicator(
      raw.idIndicator,
      String(raw.name),
      String(raw.math),
      Boolean(raw.locked),
    );
  }

  clone(): Indicator {
    return new Indicator(
      this.idIndicator,
      this.name,
      this.math,
      this.locked,
    );
  }

  toPayload(): any {
    return {
      idIndicator: this.idIndicator,
      name: this.name,
      math: this.math,
      locked: this.locked,
    };
  }
}
